/*
 * @Author: hujie striveyf@dingtalk.com
 * @Date: 2023-06-22 11:10:48
 * @LastEditors: hujie striveyf@dingtalk.com
 * @LastEditTime: 2023-06-25 15:02:19
 * @FilePath: \vysa_wifi_web\src\router\index.ts
 * @Description: 路由
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/watchHome/:iccid',
    name: 'watchHome',
    component: () => import(/* webpackChunkName: "watchHome" */ '@/views/WatchHome.vue')
  },
  {
    path: '/familyNumber/:iccid',
    name: 'familyNumber',
    component: () => import(/* webpackChunkName: "familyNumber" */ '@/views/FamilyNumber.vue')
  },
  {
    path: '/:iccid',
    name: 'wristWatch',
    component: () => import(/* webpackChunkName: "wristWatch" */ '@/views/wristWatch/index.vue')
  },
  {
    path: '/trains/:iccid',
    name: 'trains',
    component: () => import(/* webpackChunkName: "trains" */ '@/views/wristWatch/trains.vue')
  },
  {
    path: '/trainskf/:iccid',
    name: 'trainskf',
    component: () => import(/* webpackChunkName: "trainskf" */ '@/views/wristWatch/trainskf.vue')
  },
  {
    path: '/Home/:iccid',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '@/views/Home.vue')
  },
  {
    path: '/orderList/:iccid',
    name: 'orderList',
    component: () => import(/* webpackChunkName: "orderList" */ '@/views/wristWatch/orderList.vue')
  },
  {
    path: '/packageList/:iccid/:phone/:status/:operator',
    name: 'packageList',
    component: () => import(/* webpackChunkName: "packageList" */ '@/views/wristWatch/packageList.vue')
  },
  {
    path: '/packageInfo/:data',
    name: 'packageInfo',
    component: () => import(/* webpackChunkName: "packageInfo" */ '@/views/wristWatch/packageInfo.vue')
  },
  {
    //购买套餐成功
    path: "/packageSucceeds/:iccid",
    name: "packageSucceeds",
    component: () =>
        import(/* webpackChunkName: "packageSucceeds" */ "@/views/wristWatch/packageSucceeds.vue"),
  },
  {
    path: '/realName/:iccid',
    name: 'realName',
    meta: {
      title: '实名认证'
    },
    component: () => import(/* webpackChunkName: "realName" */ '@/views/realName.vue')
  },
  {
    path: '/selectCard/:iccid',
    name: 'selectCard',
    meta: {
      title: '切换'
    },
    component: () => import(/* webpackChunkName: "selectCard" */ '@/views/selectCard.vue')
  },
  {
    path: '/cardData/:iccid',
    name: 'cardData',
    meta: {
      title: '卡信息'
    },
    component: () => import(/* webpackChunkName: "cardData" */ '@/views/cardData.vue')
  },
  {
    //购买套餐
    path: "/purchasePackage",
    name: "purchasePackage",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/purchasePackage.vue"),
  },
  {
    //购买套餐成功
    path: "/purchaseSucceeds",
    name: "purchaseSucceeds",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/purchaseSucceeds.vue"),
  },
  {
    //购买须知
    path: "/purchaseNotes",
    name: "purchaseNotes",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/purchaseNotes.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from ,next) => {
  if(to.path != location.pathname) {
    location.assign(to.fullPath);  
  } else {
    next();
  }
})

export default router
